import React, { useEffect, useRef } from "react";
import cn from "../../../lib/cn";
import P from "../../typography/P";

const LabeledInput = ({
    label,
    required,
    errorMessage,
    labelClass,
    className,
    wrapperClassName,
    icon,
    iconChange,
    iconWrapperClass,
    component = "input",
    ...rest
}) => {
    const isTextarea = component === "textarea";
    const textareaRef = useRef(null);

    const handleInput = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    useEffect(() => {
        if (isTextarea && textareaRef.current) {
            handleInput();
        }
    }, []);

    const Component = isTextarea ? "textarea" : "input";

    return (
        <div className={cn("mb-2 2xl:mb-3.2", wrapperClassName)}>
            <div
                className={cn(
                    "relative border border-blue-50 rounded-sm px-2 py-1.5 md:py-1.5 focus-within:border-blue duration-300 box-border capitalize",
                    className,
                    {
                        "border-red": errorMessage,
                    }
                )}
            >
                {label && (
                    <label
                        className={cn(
                            "text-xs lg:text-sm font-urbanist absolute left-1.8 -top-1 bg-white px-0.8 flex items-center gap-0.5",
                            labelClass
                        )}
                    >
                        {label}{" "}
                        {required && <span className="text-red">*</span>}
                    </label>
                )}
                <Component
                    type="text"
                    ref={isTextarea ? textareaRef : null}
                    onInput={isTextarea ? handleInput : undefined}
                    className={cn(
                        `text-sm lg:text-base text-gray-secondary placeholder:text-gray-550 border-none outline-none h-full w-full transition-all duration-300 font-vietnam font-light`,
                        {
                            "pr-3.8 lg:pr-5 ": icon,
                        }
                    )}
                    {...rest}
                />
                {icon && (
                    <div
                        className={cn(
                            `cursor-pointer absolute right-0 top-0 h-full px-1 lg:px-2 flex items-center justify-center text-gray-550 text-2xl`,
                            iconWrapperClass
                        )}
                    >
                        <span
                            onClick={() => iconChange?.()}
                            className="cursor-pointer items-center"
                        >
                            {icon}
                        </span>
                    </div>
                )}
            </div>
            {errorMessage && (
                <P className="text-red text-xs mt-0.4">{errorMessage}</P>
            )}
        </div>
    );
};

export default LabeledInput;
